import { useGlobalContext } from '../context/GlobalContext';
import { formatAmount } from '../utils/AmountFormatter';


export function useAmountFormatter() {
  const { siteInfo, currentLang } = useGlobalContext();
  
  return (amount) => formatAmount(amount, siteInfo, currentLang);
}